import fetcher, { HTTPMethods, baseHeaders } from "../../../hooks/fetcher";
import { readErrorBody } from "../../../util/apiErrorMessage";

export async function updateInfluencer(influencerId, updates) {
  return fetcher(`/api/influencer/${influencerId}`, {
    method: HTTPMethods.PUT,
    body: JSON.stringify(updates),
  });
}

async function postUserInfluencer(body) {
  const res = await window.fetch("/api/userInfluencer", {
    method: HTTPMethods.POST,
    headers: baseHeaders,
    body: JSON.stringify(body),
  });

  if (!res.ok) {
    const { message } = await readErrorBody(res);
    throw new Error(message ?? "An error occurred");
  }

  return res;
}

export async function updateUserInfluencer(influencerId, shopUserUpdate) {
  return postUserInfluencer({
    influencer_id: influencerId,
    shopUserUpdate,
  });
}

export async function addUserAccess(influencerId, userId) {
  return postUserInfluencer({
    influencer_id: influencerId,
    newShopUserObject: { user_id: userId },
  });
}
